import { render, staticRenderFns } from "./NhlPositionOpti.vue?vue&type=template&id=8effaff8&scoped=true"
import script from "./NhlPositionOpti.vue?vue&type=script&lang=js"
export * from "./NhlPositionOpti.vue?vue&type=script&lang=js"
import style0 from "./NhlPositionOpti.vue?vue&type=style&index=0&id=8effaff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8effaff8",
  null
  
)

export default component.exports